// extracted by mini-css-extract-plugin
export default {"icon":"screeningHandler_icon__lwvvO","label":"screeningHandler_label__jFdH5","optioncontainer":"screeningHandler_optioncontainer__Jkd8Q"};